/* tslint:disable */
/* eslint-disable */
/**
 * Datenbankgestalter.de API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import type { DatabaseFieldVisibilityRule } from './DatabaseFieldVisibilityRule';
import {
    DatabaseFieldVisibilityRuleFromJSON,
    DatabaseFieldVisibilityRuleFromJSONTyped,
    DatabaseFieldVisibilityRuleToJSON,
} from './DatabaseFieldVisibilityRule';
import type { DatabaseFontSizeEnum } from './DatabaseFontSizeEnum';
import {
    DatabaseFontSizeEnumFromJSON,
    DatabaseFontSizeEnumFromJSONTyped,
    DatabaseFontSizeEnumToJSON,
} from './DatabaseFontSizeEnum';
import type { DatabaseKlappzeile } from './DatabaseKlappzeile';
import {
    DatabaseKlappzeileFromJSON,
    DatabaseKlappzeileFromJSONTyped,
    DatabaseKlappzeileToJSON,
} from './DatabaseKlappzeile';
import type { DatabasePageBlock } from './DatabasePageBlock';
import {
    DatabasePageBlockFromJSON,
    DatabasePageBlockFromJSONTyped,
    DatabasePageBlockToJSON,
} from './DatabasePageBlock';
import type { DatabasePageBlockActionType } from './DatabasePageBlockActionType';
import {
    DatabasePageBlockActionTypeFromJSON,
    DatabasePageBlockActionTypeFromJSONTyped,
    DatabasePageBlockActionTypeToJSON,
} from './DatabasePageBlockActionType';

/**
 * 
 * @export
 * @interface DatabaseTextPageBlock
 */
export interface DatabaseTextPageBlock extends DatabasePageBlock {
    /**
     * 
     * @type {string}
     * @memberof DatabaseTextPageBlock
     */
    content?: string;
    /**
     * 
     * @type {string}
     * @memberof DatabaseTextPageBlock
     */
    fontFamily?: string;
    /**
     * 
     * @type {DatabaseFontSizeEnum}
     * @memberof DatabaseTextPageBlock
     */
    fontSize?: DatabaseFontSizeEnum;
    /**
     * 
     * @type {string}
     * @memberof DatabaseTextPageBlock
     */
    fontColor?: string;
    /**
     * "Auf eine Zeile schrumpfen" — der Text wird so weit verkleinert, dass er OHNE UMBRUCH in den Baustein passt.
     * WAS OHNE DIESEN SCHALTER GESCHIEHT: Der Text verkleinert sich nur so weit, bis er in die HOEHE des Bausteins passt; umbrechen darf er dabei. Eine Kopfzeile wie "ANRUFEN - ABHOLEN - ZEIT SPAREN" rutscht in einem schmalen Baustein also auf zwei Zeilen.
     * WARUM ALS SCHALTER UND NICHT AUTOMATISCH: Es gab diese Automatik schon einmal (`96c47aa3`) — zugeschnitten auf genau eine Ueberschrift. Sie wurde entfernt (`3f3c3c25`), weil an Inhalte gekoppeltes Verhalten in dieser Anwendung immer falsch liegt: Was fuer den einen Text richtig ist, zerreisst den naechsten. Jetzt entscheidet der Betreiber je Baustein.
     * Fehlt der Wert, wird umgebrochen — das bisherige Verhalten. Bestehende Bausteine veraendern sich also nicht von selbst.
     * @type {boolean}
     * @memberof DatabaseTextPageBlock
     */
    shrinkToSingleLine?: boolean;
}

/**
 * Check if a given object implements the DatabaseTextPageBlock interface.
 */
export function instanceOfDatabaseTextPageBlock(value: object): boolean {
    let isInstance = true;

    return isInstance;
}

export function DatabaseTextPageBlockFromJSON(json: any): DatabaseTextPageBlock {
    return DatabaseTextPageBlockFromJSONTyped(json, false);
}

export function DatabaseTextPageBlockFromJSONTyped(json: any, ignoreDiscriminator: boolean): DatabaseTextPageBlock {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        ...DatabasePageBlockFromJSONTyped(json, ignoreDiscriminator),
        'content': !exists(json, 'content') ? undefined : json['content'],
        'fontFamily': !exists(json, 'fontFamily') ? undefined : json['fontFamily'],
        'fontSize': !exists(json, 'fontSize') ? undefined : DatabaseFontSizeEnumFromJSON(json['fontSize']),
        'fontColor': !exists(json, 'fontColor') ? undefined : json['fontColor'],
        'shrinkToSingleLine': !exists(json, 'shrinkToSingleLine') ? undefined : json['shrinkToSingleLine'],
    };
}

export function DatabaseTextPageBlockToJSON(value?: DatabaseTextPageBlock | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        ...DatabasePageBlockToJSON(value),
        'content': value.content,
        'fontFamily': value.fontFamily,
        'fontSize': DatabaseFontSizeEnumToJSON(value.fontSize),
        'fontColor': value.fontColor,
        'shrinkToSingleLine': value.shrinkToSingleLine,
    };
}

